import { useEffect, useState } from "react";
import { AVATAR_DELETE, AVATAR_LIST } from "../../lib/config";
import { DeleteDataOnServer, GetDataListFromServer } from "../../lib/api";
import { queryHandler } from "../../lib/global_functions";
import { QUERY_AVATAR } from "../../lib/query_obj";
import AvatarModal from "./modal";
import toast from "react-hot-toast";
import { Button, Col, Modal, Popconfirm, Row } from "antd";
import { useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";

export default function Avatar() {
  const { permissions, access_token, csrf_token, ui_size } = useSelector(
    (state) => state.user
  );
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 500,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AVATAR_LIST,
      queryHandler(filter, QUERY_AVATAR, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: result, total } }) => {
        setPagin({ ...pagin, total });
        setList(result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  function closeModal(key) {
    setShowModal(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  async function deleteAvatar(id) {
    setLoading(true);
    await DeleteDataOnServer(AVATAR_DELETE, id, access_token, csrf_token)
      .then(() => {
        toast.success("Deleted avatar successfully")
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  return (
    <>
      <Row gutter={[0, 16]} justify={"end"}>
        <Col>
          {permissions.includes("AGENT_CREATE_AVATAR") && (
            <Button
              size={ui_size}
              onClick={() => setShowModal(true)}
              type="primary"
              icon={<PlusOutlined />}
            >
              Create Avatar
            </Button>
          )}
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]} justify={"space-around"}>
            {list.map((item) => (
              <Col flex={"200px"} key={item.id}>
                {permissions.includes("AGENT_DELETE_AVATAR") ? (
                  <Popconfirm
                    title="Are You Sure!"
                    description="Delete Avatar for Users, Can't recover"
                    onConfirm={() => deleteAvatar(item.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <img
                      src={item.url}
                      alt="image"
                      style={{
                        height: "200px",
                        width: "200px",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>
                ) : (
                  <img
                    src={item.url}
                    alt="image"
                    style={{
                      height: "200px",
                      width: "200px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      <Modal
        open={showModal}
        onCancel={() => closeModal(false)}
        destroyOnClose
        footer={null}
        title="Upload Avatar Form"
      >
        <AvatarModal
          closeModal={closeModal}
          loading={loading}
          setLoading={setLoading}
          getDataList={() => getDataList(pagin.page_number, pagin.per_page)}
         
        />
      </Modal>
    </>
  );
}
